var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8EyeProtection50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,40c-3.747,0-8.616-3.115-10.82-9.074C11.948,30.111,10,27.977,10,25c0-1.844,0.798-3.285,2-3.798 V20c0-6.617,5.383-12,12-12s12,5.383,12,12v1.202c1.202,0.513,2,1.954,2,3.798c0,2.977-1.948,5.111-3.18,5.926 C32.616,36.885,27.746,40,24,40z M13,23c-0.626,0-1,1.017-1,2c0,2.588,2.044,4.154,2.447,4.355l0.365,0.183l0.133,0.385 C16.98,35.808,21.58,38,24,38s7.019-2.192,9.055-8.077l0.133-0.385l0.364-0.183C33.956,29.154,36,27.588,36,25c0-0.983-0.374-2-1-2 h-1v-3c0-5.514-4.486-10-10-10s-10,4.486-10,10v3H13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13,21v2h1c0,3.5,2.5,5,4,5c1,0,1,0,2,0c3-0.001,2.5-3,4-3s1,2.999,4,3c1,0,1,0,2,0c1.5,0,4-1.5,4-5 h1v-2H13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8EyeProtection50);
export default __webpack_public_path__ + "static/media/icons8-eye-protection-50.739a498b6148720dc70e0625b8e7de51.svg";
export { ForwardRef as ReactComponent };